

export default {
  SET_ITEMS(state, payload) {
    state.invoices = payload
  },

  ADD_ITEM(state, payload) {
    state.invoices.push(payload)
  },

  UPDATE_ITEM(state, payload) {
    console.log(payload)
      const ItemIndex = state.invoices.findIndex((p) => p.id == payload.id)
      console.log(ItemIndex)
      Object.assign(state.invoices[ItemIndex], payload)
  },

  UPDATE_ITEM_STATUS(state, payload) {
    const ItemIndex = state.invoices.findIndex((p) => p.id == payload.id)
    state.invoices[ItemIndex].status = payload.status
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.invoices.findIndex((p) => p.id == itemId)
      state.invoices.splice(ItemIndex, 1)
  }
}
